/**
 * Utility for calculating uniform steps with a min and a max.  For example, with a
 * min of 2 and max of 7, and 6 steps, this helps you find that the first step is 2,
 * second step is 3 ... sixth step is 7.
 *
 * Used as a factory.  So, for the example above this utility can be used in the two following ways:
 *
 * @example
 * const service = RangeService(2, 7, 6);
 * service(2) // returns 4
 *@example
 * RangeService(2,7,6)(2) // returns 4
 * @param {number} min - min of the range
 * @param {number} max - max of the range
 * @param {number} numSteps - number of steps in the range
 * @returns {function(number)} - value of the step in the range
 */
const RangeService = (min, max, numSteps) => (stepNumber) => min +
    ((max - min) / Math.max(1, numSteps - 1)) *
        Math.min(Math.max(stepNumber, 0), numSteps - 1);
export default RangeService;
